

export default function NextArrow({ direction, display, handleClick }) {
    //display: "hide" to left the space empty - "disable" to hide completely
    //direction: if "previous" arrow pointing left - Otherwise arrow pointing right

    let styleImg;

    if (direction === "previous") {
        styleImg = { transform: "rotate(180deg)", left: "13px" }
    } else {
        styleImg = { left: "23px" }
    }


    if(display==="hide"){
        return(
            <div className=""></div>
        )
    } else if(display==="disable") {
        return(
            <></>
        )
    }
    return (
        <div className="relative duration-500 hover:bg-light-green group h-24 w-24 cursor-pointer border-[3px] border-light-green rounded-full flex justify-center items-center" onClick={handleClick}>
            <img className="absolute h-14 group-hover:hidden duration-500" alt="arrow" src="/iconslimsvet/droit.png" style={styleImg}></img>
            <p className="hidden group-hover:flex text-white font-medium text-lg duration-500">{direction === "previous" ? "Précédent" : "Suivant"}</p>
        </div>
    );
}
